window.zeroDay = (date) => {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
}


window.getFormatTime = (ts) => {
    var date = new Date(ts * 1000);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var min = date.getMinutes();
    var sec = date.getSeconds();
    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;
    hour = (hour < 10 ? "0" : "") + hour;
    min = (min < 10 ? "0" : "") + min;
    sec = (sec < 10 ? "0" : "") + sec;
    return day + '.' + month + '.' + date.getFullYear() + " " + hour + ":" + min + ":" + sec;
}

/**
 * Linien für Warnstufen
 * @param {object} canvas canvas object
 * @param {Array} area Array
 * @param {Dygraph} g Object
 * @param {Array} warnings Array
 * @param {boolean} infoLine bool
 */
window.dyDrawWarnings = (canvas, area, g, warnings, infoLine) => {
    var colors = {
        'warnings': {
            0: 'rgb(228,205,26)',
            1: 'rgb(255,0,26)',
            2: 'rgb(37,64,143)'
        }
    };

    // var lastY = 0;
    var x = warnings.sort(function(a, b) {
        return parseFloat(a[1]) < parseFloat(b[1]) ? -1 : 1;
    });

    for (var i = 0; i < warnings.length; i++) {
        // Selecting a date in the middle of the graph.
        var splitDate = new Date().getTime();
        var coords = g.toDomCoords(splitDate, warnings[i][1]);
        var yPos = coords[1];
        var lineHeight = 1;
        if (infoLine) {
            canvas.fillStyle = '#25408f';
        } else {
            canvas.fillStyle = colors.warnings[i]; // 'green';
        }
        canvas.fillRect(area.x, yPos, area.w, lineHeight);
        canvas.font = '12px Arial';
        canvas.fillText(warnings[i][0], area.x + 5, yPos - 2);
        // var canvas_bottom = g.toDomYCoord(lastY);
        // var canvas_top = g.toDomYCoord(warnings[i][1]);
        // var canvas_height = canvas_top - canvas_bottom;
        // canvas.fillStyle = colors.warnings[i];;//'rgba(255, 0, 0, 1.0)';
        // canvas.fillRect(area.x, canvas_bottom, area.w, canvas_height);
        // lastY = warnings[i][1];
    }
}

/**
 * Diagramm-Bereiche hervorheben
 * Diese Methode muss vor den Warnlinien {@see window.dyDrawWarnings} ausgeführt werden, da sonst die Linien überdeckt werden.
 * @param canvas
 * @param area
 * @param g
 * @param diagramAreas
 */
window.dyDrawAreas = (canvas, area, g, diagramAreas) => {
    //Für alle Diagrammbereiche im Array
    for (const diagramAreasKey in diagramAreas) {
        // Bestimme die Grenzen des Bereichs
        const diagramArea = diagramAreas[diagramAreasKey];
        var minY = g.toDomYCoord(diagramArea.minY);
        var maxY = g.toDomYCoord(diagramArea.maxY);

        // Hebe den Bereich farbig hervor
        canvas.fillStyle = diagramArea.style;
        canvas._zIndex = -1;
        canvas.fillRect(area.x, maxY, area.w, minY - maxY);

        // Schreibe den Text des Bereichs in weiß darüber.
        canvas.fillStyle = 'white';
        canvas.font = 'small-caps bold 15px Arial';
        canvas.fillText(diagramArea.label, area.x + 5, Math.max(area.y, maxY) + 16 );
    }
}



/**
 * Diagramm
 **/
function init () {
    var $dias = $('.dia-tabs');

    //	$( window ).resize(function() {
    //		toggleDia();
    //	});
    function toggleDia() {
        if ($(window).width() < 600) {
            $dias.hide();
            // Nur bei abgeschaltetem Ddebug!
            if ($dias.parents(':eq(1)').prev().hasClass('bar-text')) {
                $dias.parents(':eq(1)').prev().hide();
            }
        } else {
            $dias.show();
            if ($dias.parents(':eq(1)').prev().hasClass('bar-text')) {
                $dias.parents(':eq(1)').prev().show();
            }
        }
    }
    //toggleDia();
    // Farben für Niederschlag
    var colors = {
        '24': [{
                value: 10,
                color: 'rgb(37,64,143)'
            }, // Nass
            {
                value: 5,
                color: 'rgb(37,64,143)'
            }, // etwas nass
            {
                value: 2,
                color: 'rgb(37,64,143)'
            }, // mittel
            {
                value: 0.1,
                color: 'rgb(37,64,143)'
            }, // etwas trocken
            {
                value: 0,
                color: 'rgb(37,64,143)'
            }, // trocken, nie sichtbar...
        ],
        '6': [{
                value: 10,
                color: 'rgb(37,64,143)'
            }, // Nass
            {
                value: 5,
                color: 'rgb(37,64,143)'
            }, // etwas nass
            {
                value: 2,
                color: 'rgb(37,64,143)'
            }, // mittel
            {
                value: 0.1,
                color: 'rgb(37,64,143)'
            }, // etwas trocken
            {
                value: 0,
                color: 'rgb(37,64,143)'
            }, // trocken, nie sichtbar...
        ],
        '1': [{
                value: 10,
                color: 'rgb(37,64,143)'
            }, // Nass
            {
                value: 5,
                color: 'rgb(37,64,143)'
            }, // etwas nass
            {
                value: 2,
                color: 'rgb(37,64,143)'
            }, // mittel
            {
                value: 0.1,
                color: 'rgb(37,64,143)'
            }, // etwas trocken
            {
                value: 0,
                color: 'rgb(37,64,143)'
            }, // trocken, nie sichtbar...
        ],
        'Sm': [{
                value: 1.5,
                color: 'rgb(37,64,143)',
                text: 'sehr nass'
            }, // Nass
            {
                value: 1.2,
                color: 'rgb(135,149,193)',
                text: 'etwas zu nass'
            }, // etwas nass
            {
                value: 0.8,
                color: 'rgb(0,123,124)',
                text: 'durchschnittlich'
            }, // mittel
            {
                value: 0.5,
                color: 'rgb(255,204,0)',
                text: 'etwas zu trocken'
            }, // etwas zu trocken
            {
                value: 0.0,
                color: 'rgb(190,15,63)',
                text: 'sehr trocken'
            } // sehr trocken
        ],
        'colorDefault': 'rgb(37,64,143)',
        'mondayLongTimes': 'rgb(243,147,19)'
    };
    var defaultHours = 24;

    window.graph = Array();

    var colorDefault = 'rgb(37,64,143)'; // Dunkles Blau: @base-dark-color #25408f
    var colorTemp = 'rgb(190,10,10)'; // Dunkles Rot für Lufttemperatur
    var colorGanglinie = 'rgb(243,147,19)';
    var colorOL = 'rgb(128,0,0)'; // Orientierungslinie
    var colorSR = 'rgb(0,0,128)'; // Schutzraum
    var colorPrognose = 'rgb(243,147,19)'; // Schutzraum
    var colorPrognoseBG = 'rgba(222,226,238,0.6)'; // Hintergrundfarbe Prognose
    //var colorQuantile = "rgba(37,64,143,0.8)"
    var colorQuantile = colorOL; //"rgba(200,64,143,0.8)"
    // 25408f
    var $this = this;
    var graph = {};
    var allG = Array();
    $('#status-helper').hide();
    $('.graph').each(function(i, el) {
        var stationId = $(el).attr('data-id');
        var stationType = $(el).attr('data-stationtype'); // P,W,ST,G,T
        var stationPara = $(el).attr('data-type'); // Parameterkürzel
        var divId = $(el).attr('id');

        var warnings = null;
        var dataTypes = new Array();
        if ($(this).attr('data-types')) {
            dataTypes = JSON.parse($(this).attr('data-types'));
        }
        var $title = false;
        if ($(this).attr('data-title')) {
            $title = $(this).attr('data-title');
        }

        var diagramAreas = getDiagramAreas(stationId, stationType, stationPara);

        if (!$('body').hasClass('snapshot')) {
            var id = $(el).attr('data-id'); // "SHUE";
            var url = '/Handler/PegelData?pid=' + id;
            if ($(el).attr('data-url')) {
                url = '/Handler/Parameter/' + $(el).attr('data-url') + '?pid=' + id;
            }
            var params = new URLSearchParams(location.search)
            if (params.get('ts')) {
                url += "&ts=" + params.get('ts');
            }
        } else {
            // Snapshot Daten
            // Parametrname fehlt!!!
            url = $('body').attr('data-name') + '/_data/' + $(el).attr('data-stationType') + '/' + $(el).attr('data-url') + '/' + $(el).attr('data-id');
        }
        // Daten holen
        // Müssen beim Niederschlag überarbeitet werden
        var $data = getData(url);
        if ($data.length === 2) {
            // warnstufen sollen eingezeichnet werden
            warnings = $data[0].split(';');
            for (var w = 0; w < warnings.length - 1; w++) {
                warnings[w] = warnings[w].split(':');
            }
            $data = $data[1];
        }
        var $graphData = $data; // $.csv.toArrays($data);

        if ($graphData.length === 0 || $graphData.match(/^\[?\]$/)) {
            // Keine Daten vorhanden
            $(el).children().html('<p class="err-info"><strong>Keine Daten vorhanden</strong></p>');
            return true;
        }

        var $labelFirst = ($(el).attr('data-legend') ? $(el).attr('data-legend') : "Wasserstand");
        var gType = $(el).attr('data-type');
        var gLabels = ["Datum", $labelFirst];
        var gSeries = {};
        gSeries[$labelFirst] = {
            color: colorDefault
        };
        for (var n = 0; n < dataTypes.length; n++) {
            gSeries[dataTypes[n].title] = {};
            if (dataTypes[n].color) {
                gSeries[dataTypes[n].title].color = colors[dataTypes[n].color];
            }
            if (dataTypes[n].plotter) {
                gSeries[dataTypes[n].title].plotter = eval(dataTypes[n].plotter);
            }
            if (dataTypes[n].drawPoints) {
                gSeries[dataTypes[n].title].drawPoints = eval(dataTypes[n].drawPoints);
            }
            if (dataTypes[n].pointSize) {
                gSeries[dataTypes[n].title].pointSize = dataTypes[n].pointSize;
            }
            // Erste Label ist immer "Datum"
            if (n > 0) {
                gLabels.push(dataTypes[n].title);
            }
        }
        var g = {
            type: gType
        };

        var graphData_array = $graphData.split("\n").map(function(x) {
            return x.split(",")
        });
        var barWidth = 10;
        var startZoom = false;
        switch (gType) {
            case 'SF':
                // Talsperre Speicherfüllstand
                gSeries['Orientierungslinie'] = {
                    color: colorOL
                };
                gLabels.push("Orientierungslinie");
                gSeries['Schutzraum'] = {
                    color: colorSR
                };
                gLabels.push("Schutzraum");
                startZoom = true;
                break;
            case 'SI':
                // Talsperre Speicherinhalt
                gSeries['Orientierungslinie'] = {
                    color: colorOL
                };
                gLabels.push("Orientierungslinie");
                gSeries['Schutzraum'] = {
                    color: colorSR
                };
                gLabels.push("Schutzraum");

                if (graphData_array.testPrognose(4)) {
                    gSeries['Prognose'] = {
                        color: colorPrognose,
                        drawPoints: true,
                        pointSize: 1,
                        plotter: PrognoselinePlotter
                    };
                    gLabels.push("Prognose");
                }
                startZoom = true;
                break;
            case 'W':
                // Pegelstation Wasserstand
                gSeries['Quantile 75'] = {
                    color: colorQuantile,
                    plotter: fillChartPlotter
                };
                gLabels.push("Quantile 75");
                gSeries['Quantile 25'] = {
                    color: colorQuantile
                };
                gLabels.push("Quantile 25");
                //if (graphData_array.testPrognose(4)) {
                if (graphData_array[0].length === 5) {
                    gSeries['Prognose'] = {
                        color: colorPrognose,
                        plotter: PrognoselinePlotter
                    };
                    gLabels.push("Prognose");
                }
                break;
            case 'WT':
                break;
            case 'A':
                // Pegelstation Abfluss
                gSeries['Quantile 75'] = {
                    color: colorQuantile,
                    plotter: fillChartPlotter
                };
                gLabels.push("Quantile 75");
                gSeries['Quantile 25'] = {
                    color: colorQuantile
                };
                gLabels.push("Quantile 25");
                // Prognose nur wenn Daten vorhanden sind
                //if (graphData_array.testPrognose(4)) {
                if (graphData_array[0].length === 5) {
                    gSeries['Prognose'] = {
                        color: colorPrognose,
                        plotter: PrognoselinePlotter
                    };
                    gLabels.push("Prognose");
                }
                break;
            case 'L':

                gSeries[$labelFirst] = {
                    color: colorTemp
                };
                //if (graphData_array.testPrognose(2)) {
                if (graphData_array[0].length === 3) {
                    gSeries['Prognose'] = {
                        color: colorPrognose,
                        plotter: PrognoselinePlotter
                    };
                    gLabels.push("Prognose");
                }
                break;
            case 'N':
                // Wetterstation Niederschlag
                gSeries[$labelFirst] = {
                    plotter: barChartPlotter
                };
                $graphData = $.csv.toArrays($data);
                $graphData = graphNiederschlagData(defaultHours, $graphData);
                var p = 1;
                while (graphData_array[graphData_array.length - p][0] === '' && p < 10) {
                    p++;
                }
                if (parseInt(graphData_array[graphData_array.length - p][0]) > (new Date().getTime() / 1000 | 0)) {
                    gSeries['Vorhersage [mm]'] = {
                        plotter: barChartPlotter,
                        color: colorGanglinie
                    };
                    gLabels.push("Vorhersage [mm]");
                } else {
                    for (var q = 0; q < $graphData.length; q++) {
                        $graphData[q].pop();
                    }
                }
                barWidth = ($(this).width() - 70) / $graphData.length;
                g = graphNiederschlag(el, gLabels, gSeries, $labelFirst, null, allG, null, barWidth, true, null, $title, warnings);
                g.type = "N";
                // kein Y-Zoom bei Niederschlag
                // options-timespan
                $(el).parent().find('.zoom-y').remove();
                $(el).parent().find('.options-timespan').remove();
                break;
            case 'MN':
                if ($(this).width() - 70 <= 0) {
                    // hidden tab
                    barWidth = (975) / $.csv.toArrays($data).length;
                } else {
                    barWidth = ($(this).width() - 70) / $.csv.toArrays($data).length;
                }
                g = graphNiederschlag(el, gLabels, gSeries, $title, null, allG, $data, barWidth, true, 'Sm');
                g.type = gType;
                break;
        }
        g.gType = gType;
        // Neu: Informative Warnwerte
        var infoWarnings = [];
        if (gType !== 'MN' && gType !== 'SSM') {
            $.ajax({
                cache: false,
                type: "POST",
                async: false,
                url: '/Handler/Parameter/Warnings',
                data: {
                    data: {
                        action: 'read',
                        stationId: id,
                        stationType: stationType,
                        param: stationPara
                    }
                }
            }).done(function(iWarnings) {
                iWarnings = JSON.parse(iWarnings);

                if (iWarnings.items.length > 0) {
                    for (var n = 0; n < iWarnings.items.length; n++) {
                        infoWarnings[n] = [iWarnings.items[n].label, iWarnings.items[n].value];
                    }
                }
            });
        }
        if (gType !== 'MN' && gType !== 'N' && $graphData.length > 0) {
            // Min und Maxwerte Berechnen für die Y-Achse im Graph
            var values = $.csv.toArrays($data);
            var max = values.MaxTimeLine();
            var min = values.MinTimeLine();
            min = Math.floor(min);
            max = Math.ceil(max);

            var scala = getMinMax(warnings, min, max);
            // NEU: infoWarnings mit einbeziehen
            if (infoWarnings.length > 0) {
                var iScala = getMinMax(infoWarnings, min, max);
                if (iScala.max > scala.max) {
                    scala.max = iScala.max;
                }
                if (iScala.min < scala.min) {
                    scala.min = iScala.min;
                }
            }
            if (gType !== 'L') {
                min = scala.min;
            }
            max = scala.max;
            if (min <= 0) {
                $(el).find('.zoom-y').hide();
            } else {
                // Min bei start immer 0, sofern nicht negativ
                min = 0;
                g.byZero = true;
            }

            /* Graph initialisieren */
            // zoom-y buttons
            var zoomYBtn = $('.zoom-' + divId);
            if (zoomYBtn.length) {
                zoomYBtn[0].dataset.dispatch = 'false';
            }
            g = new Dygraph(
                el,
                $graphData, {
                    legend: 'always',
                    warnings: warnings,
                    underlayCallback: function(canvas, area, g) {
                        if (null !== diagramAreas) {
                            g.diagramAreas = diagramAreas;
                            dyDrawAreas(canvas, area, g, diagramAreas);
                        }

                        if (warnings !== null) {
                            g.warnings = warnings;
                            dyDrawWarnings(canvas, area, g, warnings, false);
                        }
                        if (infoWarnings.length > 0) {
                            g.infoWarnings = infoWarnings;
                            infoWarnings[infoWarnings.length] = "";
                            dyDrawWarnings(canvas, area, g, infoWarnings, true);
                        }
                        if (zoomYBtn.length && zoomYBtn[0].classList.contains('active') && zoomYBtn[0].dataset.dispatch === 'true') {
                            zoomYBtn[0].dispatchEvent(new Event('click'));
                        }
                    },
                    highlightSeriesOpts: {
                        strokeWidth: 2,
                        strokeBorderWidth: 1,
                        highlightCircleSize: 3,
                    },
                    valueRange: [min, max],
                    //xRangePad: 20,
                    pointSize: 1,
                    drawPoints: false,
                    connectSeparatedPoints: true,
                    drawGapEdgePoints: true,
                    //includeZero: true,
                    labels: gLabels,
                    series: gSeries,
                    //hideOverlayOnMouseOut: true,
                    title: ($title || $labelFirst),
                    height: 400,
                    xAxisHeight: 50,
                    pixelsPerLabel: 40,
                    drawAxesAtZero: false,
                    interactionModel: {}, // ZOOM deaktiviert
                    gridLineWidth: 0.6,
                    // legendFormatter: legendFormatter,
                    /* Wenn aktiviert:
                     * Nach klick auf 7,3,1 Tag werden keine y-labels mehr angezeigt
                     */
                    axes: {
                        y: {
                            valueFormatter: function(ms) {
                                return parseFloat(ms).toFixed(2);
                            }
                        },
                        x: {
                            ticker: function(min, max, pixels, opts, dygraph, vals) {
                                var tickVals = new Array();
                                if (gType === 'SSM') {
                                    // Montagsbericht
                                    // 01.11.vorjahr 00:00 bis 31.10.aktuelles jahr 00:00
                                    var startDate = new Date('11/1/' + (new Date().getYear() + 1900 - 1));
                                    for (var i = 0; i < 12; i++) {
                                        var t = {
                                            v: (startDate.getTime() / 1000),
                                            label: '<span class="dia-date" style="font-weight: bold">01.' + ("0" + (startDate.getMonth() + 1)).slice(-2) + '</span><br /><span class="dia-time">00:00</span>'
                                        };
                                        tickVals.push(t);
                                        startDate.setMonth(startDate.getMonth() + 1);
                                    }
                                    return tickVals;
                                }

                                var hDiff = parseInt((max - min) / (60 * 60));
                                var mod = (24 * 60 * 60); // default 24 Stunden Takt
                                if (hDiff < 72) {
                                    mod = (6 * 60 * 60); // 6 Stunden Takt
                                    //mod = (60 * 60);	// WUP- 480 1 Stunden Takt
                                }
                                if (hDiff <= 24) {
                                    mod = (4 * 60 * 60); // Stundentakt
                                    //mod = (15 * 60);	            // WUP- 480 15 Minuten Takt
                                }
                                if (hDiff <= 12) {
                                    mod = (30 * 60); // 30 Minuten
                                }
                                if (hDiff <= 4) {
                                    mod = (10 * 60); // 10 Minuten
                                }
                                if (hDiff > 1000) { // Montagsbericht hDiff / 300 Tage
                                    mod = parseInt(hDiff / 300) * (24 * 60 * 60);
                                }

                                max = parseInt(max);
                                fullData = dygraph.rawData_;
                                var startTS = parseInt(zeroDay(new Date(min * 1000)).getTime() / 1000);
                                while (startTS <= max) {
                                    var ts = startTS;
                                    var date = new Date(ts * 1000);
                                    var month = date.getMonth() + 1;
                                    var day = date.getDate();
                                    var hour = date.getHours();
                                    min = date.getMinutes();
                                    month = (month < 10 ? "0" : "") + month;
                                    day = (day < 10 ? "0" : "") + day;
                                    hour = (hour < 10 ? "0" : "") + hour;
                                    min = (min < 10 ? "0" : "") + min;
                                    t = {
                                        v: startTS,
                                        label: '<span class="dia-date" style="font-weight: bold">' + day + '.' + month + '</span><br /><span class="dia-time">' + hour + ":" + min + '</span>'
                                    };
                                    tickVals.push(t);
                                    startTS += (mod);
                                }
                                return tickVals;

                                //return [{v:1454592420, label:"aaaaaaa"}, {v:1454608500, label:"5"}, {v:1454619960, label:"10"}];
                            },

                            axisLabelFormatter: function(ts, gran, opts, d) {
                                var date = new Date(ts * 1000);
                                var month = date.getMonth() + 1;
                                var day = date.getDate();
                                var hour = date.getHours();
                                min = date.getMinutes();
                                month = (month < 10 ? "0" : "") + month;
                                day = (day < 10 ? "0" : "") + day;
                                hour = (hour < 10 ? "0" : "") + hour;
                                min = (min < 10 ? "0" : "") + min;
                                return '<span class="dia-date" style="font-weight: bold">' + day + '.' + month + '</span><br /><span class="dia-time">' + hour + ":" + min + '</span>';
                            },
                            valueFormatter: function(ts) {
                                var date = new Date(ts * 1000);
                                var month = date.getMonth() + 1;
                                var day = date.getDate();
                                var hour = date.getHours();
                                min = date.getMinutes();
                                var sec = date.getSeconds();
                                month = (month < 10 ? "0" : "") + month;
                                day = (day < 10 ? "0" : "") + day;
                                hour = (hour < 10 ? "0" : "") + hour;
                                min = (min < 10 ? "0" : "") + min;
                                sec = (sec < 10 ? "0" : "") + sec;
                                return '<div class="legendTime pull-left" style="width:12em;">' + day + '.' + month + '.' + date.getFullYear() + " " + hour + ":" + min + ":" + sec + '</div>';
                            }
                        }
                    },
                    highlightCallback: function(event, x, points, row, seriesName) {
                        var container = el.parentElement;
                        container.querySelector('.highlightedTime').innerHTML = getFormatTime(x);
                        if (container.querySelector('.dia-value span')) {
                            container.querySelector('.dia-value span').innerHTML = '';
                        }
                        // WUPSUPP-267
                        var decimalPlaces = gType === 'SF' || gType === 'SI' ? 2 : 1;
                        $(points).each(function(i, el) {
                            var legendElName = el.name.replace(/\/|³|²|\s|\[|\]/gi, '_');
                            container.querySelector('.' + legendElName).innerHTML = parseFloat(el.yval).toFixed(decimalPlaces);
                        });
                    },
                    //legend: 'hide',
                    //labelsDiv : legendContainer,
                    labelsSeparateLines: false,
                    showLabelsOnHighlight: true,
                    hideOverlayOnMouseOut: false,
                    ylabel: ($(el).attr('data-legend') ? $(el).attr('data-legend') : "Wasserstand"),
                    labelsDivWidth: 0,
                    zoomCallback: function(event) {},
                    drawCallback: function(me, initial) {}
                }
            );
            g.type = gType;



        } else if (DEBUG && gType !== 'MN' && gType !== 'N' && $graphData.length === 0) {
            console.log($labelFirst + " : Keine Daten");
            return true;
        }

        g.url = url;
        g.sourceData = $data;
        g.tabClicked = false;
        allG.push(g);

        // Zoom zurück setzen Button
        var zoomButton = $(this).parent().find('.dia-zoom-reset');
        zoomButton.hide();
        if (g.type !== 'N') {
            zoomButton.click(function(event) {
                g.updateOptions({
                    dateWindow: null,
                    valueRange: null
                });
            });
            g.zoomButton = zoomButton;
        }
        // Buttons Zeitspanne
        var timeSpans = $(this).parent().find('a.timespan');
        timeSpans.click(function(event) {
            timeSpans.removeClass('active');
            $(this).addClass('active');
            if (!zoomYBtn) {
                zoomYBtn = zoomButton;
            }
            if (zoomYBtn.length) {
                if (zoomYBtn[0].classList.contains('active')) {
                    zoomYBtn[0].dataset.dispatch = 'true';
                }
            }
            return false;
        });


        // Tooltips nur beim Montagsbericht
        if (g.tooltips) {
            g.ready(function() {
                var anot = new Array();
                for (var t = 0; t < g.tooltips.length; t++) {
                    var a = {
                        series: $labelFirst,
                        x: g.tooltips[t][0],
                        cssClass: 'ttGraphSm',
                        text: g.tooltips[t][1],
                        width: g.tooltips[t][2],
                        height: g.tooltips[t][3],
                        attachAtBottom: true
                    };
                    anot.push(a)
                }
                g.setAnnotations(anot);
            });
        }
        $(".drp-timespan").selectmenu({
            width: 100,
            change: function(event, ui) {
                //
            }
        });
        g.byZero = true;

        this.graph = g;
        this.graph.zoomYButton = $('.zoom-' + divId)[0];
        $('.zoom-' + divId).unbind().click(function(event) {
            if (this.dataset.dispatch === 'false') {
                this.classList.toggle('active');
            }
            this.dataset.dispatch = 'false';
            if (g.xFrom) {
                zoomGraphY(g, this);
                g.updateOptions({
                    dateWindow: [g.minDate, g.lastX]
                });
            } else {
                zoomGraphY(g, this);
            }

            return false;
        });

        $($('.graph')[i]).parent().find('.dia-zoom').click(function(event) {
            g.xFrom = $(this).attr('data-from')
            if (g.xFrom < g.rawData_[0][0]) {
                g.xFrom = g.rawData_[0][0];
            }
            g.dataFrom = $(this).attr('data-to');
            g.dataDays = $(this).attr('data-days');
            zoomGraphX(g, g.xFrom, g.dataFrom, g.dataDays);
            return false;
        });
        if (startZoom) {
            this.graph.zoomYButton.classList.add('active');
            zoomGraphY(g, this.graph.zoomYButton);
        }
        window.graph.push(this);
    });

    window.dygraphs = allG;

    $('.dia-tabs').each(function(i) {
        setGraphLabel(null, $(this).find('li a')[0]);
    });

    function getData(url) {
        var retData = '';
        if (location.href.indexOf('bericht') === -1) {
            url += "&default=1";
        }
        $.ajax({
            cache: false,
            type: "GET",
            async: false,
            url: url
        }).done(function(data) {
            retData = data;
        });
        var w = retData.split('|');
        if (w.length > 1) {
            // warnwerte vorhanden
            // Warnstufe 1 = Hochwasserwarnung
            // Warnstufe 2 = Hochwasseralarm
            w[0] = w[0].replace('Warnstufe 1', 'Hochwasserwarnung');
            w[0] = w[0].replace('Warnstufe 2', 'Hochwasseralarm');
            retData = w;
            warnings = w[0];
        }
        return retData;
    }

     /**
      * Diagrammbereiche per Ajax holen
      * @param stationId Die Station, für die die Einträge geholt werden sollen
      * @param stationType Die Art der Station, für die die Einträge geholt werden sollen
      * @param parameterType Der Parameter, für den die Einträge geholt werden sollen
      * @returns {*[]} Objekt-Liste von Einträgen
      */
    function getDiagramAreas(stationId, stationType, parameterType) {
         var retData = [];
         url = `/diagramarea/list/${stationId}/${stationType}/${parameterType}`;
         $.ajax({
             cache: false,
             type: "GET",
             async: false,
             url: url,
         }).done(function(data) {
             retData = data;
         });
         return retData;
     }


    // Multiple column bar chart
    function multiColumnBarPlotter(e) {
        // We need to handle all the series simultaneously.
        if (e.seriesIndex !== 0) return;
        var g = e.dygraph;
        var ctx = e.drawingContext;
        var sets = e.allSeriesPoints;
        var y_bottom = e.dygraph.toDomYCoord(0);
        var min_sep = Infinity;
        var j = 0;
        var i = 0;

        for (j = 0; j < sets.length; j++) {
            var points = sets[j];
            for (i = 1; i < points.length; i++) {
                var sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep) min_sep = sep;
            }
        }
        var bar_width = Math.floor(2.0 / 3 * min_sep);
        var fillColors = [];
        var strokeColors = g.getColors();
        //colorGanglinie
        fillColors.push(colors[0]);
        fillColors.push(colorPrognose);
        for (j = 0; j < sets.length; j++) {
            ctx.fillStyle = fillColors[j];
            ctx.strokeStyle = strokeColors[j];
            for (i = 0; i < sets[j].length; i++) {
                var p = sets[j][i];
                var center_x = p.canvasx;
                var x_left = center_x - (bar_width / 2) * (1 - j / (sets.length - 1));
                ctx.fillRect(x_left, p.canvasy,
                    bar_width / sets.length, y_bottom - p.canvasy);
                ctx.strokeRect(x_left, p.canvasy,
                    bar_width / sets.length, y_bottom - p.canvasy);
            }
        }
    }

    function zoomGraphX(g, minDate, maxDate, days) {

        // Letzter Wert ist nicht unbedingt maxDate, z.B. bei einer Datenlücke
        $('.graph-info').remove();
        var lastX = g.getValue(g.numRows() - 1, 0);
        var max = 0;

        // Bei Niederschlag müssen die Daten neu geholt werden!
        if (g.type === 'N') {
            var newData;
            if (days === '7') {
                // min vom handlöer berechnen lassen
                newData = getData(g.url + '&t=7', g);
            } else {
                newData = getData(g.url + '&min=' + minDate + '&t=' + days, g);
            }

            //var newData = getData(g.url);
            if (newData.length === 2) {

                // warnstufen sollen eingezeichnet werden
                warnings = newData[0].split(';');
                for (var w = 0; w < warnings.length - 1; w++) {
                    warnings[w] = warnings[w].split(':');
                }
                newData = newData[1];
            }

            newData = $.csv.toArrays(newData);
            var hours = defaultHours;
            switch (days) {
                case '7':
                    hours = 24;
                    g.xAxisStep = 1;
                    break;
                case '3':
                    hours = 12;
                    hours = 1; // WUP-480
                    g.xAxisStep = 4;
                    break;
                case '1':
                    hours = 4;
                    hours = 1;
                    hours = 0.25; // WUP-480
                    g.xAxisStep = 8;
                    //                    hours = 0.5;
                    break;
                default:
                    hours = defaultHours;
            }
            g.zoomlevel = hours;
            var legends = $('.dia-status>div').length;
            newData = graphNiederschlagData(hours, newData);

            // lastX aus neuen Daten holen
            lastX = newData[newData.length - 1][0];
            while (newData[0].length > legends) {
                for (var q = 0; q < newData.length; q++) {
                    newData[q].pop();
                }
            }
            for (var i = 0; i < newData.length; i++) {
                if (!isNaN(newData[i][1]) && newData[i][1] > max) {
                    max = newData[i][1];
                }
                if (newData[i].length > 2) {
                    if (!isNaN(newData[i][2]) && newData[i][2] > max) {
                        max = newData[i][2];
                    }
                }
                // Nur bei Niederschlag muss der letzte Wert nach neuladen entfernt werden
                if (newData[i][newData[i].length - 1] === "NaN") {
                    newData[i].pop();
                }
            }
            max = Math.ceil(max);

            if (days === '7') {
                g.xFrom = null;
                g.updateOptions({
                    valueRange: [0, max],
                    'file': newData,
                    dateWindow: null
                });
            } else {
                g.minDate = minDate;
                g.lastX = lastX;
                g.updateOptions({
                    valueRange: [0, max],
                    'file': newData,
                    dateWindow: [minDate, lastX]
                });
            }
        } else {
            // Warnwerte evtl. höher als der letzte max wert
            max = g.rawData_.MaxTimeLine();
            var min = g.rawData_.MinTimeLine();

            var scala = getMinMax(g.warnings, min, max);

            if (g.infoWarnings && g.infoWarnings.length > 0) {
                var iScala = getMinMax(g.infoWarnings, min, max);
                if (iScala.max > scala.max) {
                    scala.max = iScala.max;
                }
                if (iScala.min < scala.min) {
                    scala.min = iScala.min;
                }
            }
            if (scala.min > 0) {
                scala.min = 0;
            }
            g.byZero = true; // 0 aktiv, auch bei negativ
            g.minDate = minDate;
            g.lastX = lastX;

            g.updateOptions({
                dateWindow: [minDate, lastX],
                valueRange: [scala.min, scala.max]
            });

            if (minDate >= lastX) {
                var msg = $('<div class="graph-info"><i class="icon-attention"></i><br />Für den gewählten Zeitraum liegen keine Daten vor</div>');
                $(g.maindiv_).append(msg);
            }
        }
    }

    function zoomGraphY(g) {
        var max = g.rawData_.MaxTimeLine();
        var min = g.rawData_.MinTimeLine();
        var scala = getMinMax(g.warnings, min, max);

        if ((/lufttemperatur/i).test(g.url)) {
            // WUPSUPP-129 Lufttemperatur negative temperaturen
            scala.min = parseInt(Math.floor(min));
        }

        if (!g.byZero && g.infoWarnings && g.infoWarnings.length > 0) {
            var iScala = getMinMax(g.infoWarnings, min, max);
            if (iScala.max > scala.max) {
                scala.max = iScala.max;
            }
            if (iScala.min < scala.min) {
                scala.min = iScala.min;
            }
        }

        if (g.byZero) { // && scala.min >= 0) {
            g.byZero = false;
            scala.max = max;
        } else {
            if (!(/lufttemperatur/i).test(g.url)) {
                scala.min = 0;
            }
            g.byZero = true;
        }

        if (scala.min > 0) {
            g.updateOptions({
                dateWindow: null,
                valueRange: null
            });
        } else {
            g.updateOptions({
                valueRange: [scala.min, scala.max]
            });
        }
    }

    function getMinMax(warnings, min, max) {
        if (warnings) {
            for (var w = 0; w < warnings.length; w++) {
                if (typeof(warnings[w]) === 'object' && max < parseFloat(warnings[w][1])) {
                    max = warnings[w][1];
                }
            }
        }
        max = parseInt(Math.ceil(max));
        min = parseInt(Math.floor(min));
        if (max - min > 10) {
            if (min >= 0) {
                min = min - min % 10;
            }
            max = max - max % 10 + 10;
        }
        if (max - min < 20) { // WUPSUPP-169
            max = max * 2;
        }
        if (min > 0 && max - min > 10) {
            min = min - min % 10;
            max = max - max % 10 + 10;
        } else {
            max += 1;
        }

        if (min < 0 && min > -30) {
            min = min - min % 10 * -1;
        }
        return {
            min: Math.floor(min),
            max: Math.ceil(max)
        };
    }

    /**
     * Plotter für Balken (Bars)
     * @param {number} e context
     */
    function barChartPlotter(e) {
        var ctx = e.drawingContext;
        var points = e.points;
        var y_bottom = e.dygraph.toDomYCoord(0);
        var i = 0;
        var min_sep = Infinity;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        for (i = 1; i < points.length; i++) {
            var sep = points[i].canvasx - points[i - 1].canvasx;
            if (sep < min_sep && sep > 0) min_sep = sep;
        }

        //var bar_width = Math.floor(1 / 2 * min_sep);
        var bar_width = min_sep; //Math.floor(1 / 2 * min_sep);
        bar_width /= 1.2;
        var startWidth = bar_width;
        // e.dygraph.attributes_.user_.smColors
        var colorHash = (e.dygraph.attributes_.user_.smColors !== null ? e.dygraph.attributes_.user_.smColors : defaultHours);
        if (e.dygraph.attributes_.user_.smColors !== null) {
            e.dygraph.tooltips = new Array();
        }
        var offsetLeft = 0; // min_sep / 2;
        //bar_width -= 10;
        var c = 0;
        for (i = 0; i < points.length; i++) {
            var p = points[i];
            var center_x = p.canvasx;
            var pointDate = new Date(p.xval * 1000);
            if (new Date().getTime() / 1000 < p.xval) {
                for (c = 0; c < colors[colorHash].length; c++) {
                    if (e.dygraph.attributes_.user_.smColors !== null) {
                        // Text Prognose
                        if (e.dygraph.rolledSeries_[2][i][1] * colors[colorHash][c].value < p.yval) {
                            // Prognose mit Transparenz
                            var pColor = colors[colorHash][c].color.replace(')', ', 0.6)').replace('rgb', 'rgba');
                            ctx.fillStyle = pColor;
                            e.dygraph.tooltips.push([e.dygraph.rolledSeries_[2][i][0], "Prognose: " + colors[colorHash][c].text, bar_width, y_bottom - p.canvasy, colors[colorHash][c].cssClass]);
                            break;
                        }
                    }
                }
            } else {
                for (c = 0; c < colors[colorHash].length; c++) {

                    if (e.dygraph.attributes_.user_.smColors !== null) {
                        // Text und Farbe Balken, Nur bei SM
                        if (parseFloat(e.dygraph.rolledSeries_[2][i][1]) * parseFloat(colors[colorHash][c].value) < parseFloat(p.yval)) {
                            ctx.fillStyle = colors[colorHash][c].color;
                            e.dygraph.tooltips.push([e.dygraph.rolledSeries_[2][i][0], colors[colorHash][c].text, bar_width, y_bottom - p.canvasy, colors[colorHash][c].cssClass]);
                            break;
                        }
                    } else {
                        // Niederschlag default nur balken ohne tooltip/Farben

                        if (p.yval >= colors[colorHash][c].value) {
                            // if ( points.length < 11 && new Date( p.xval * 1000 ).toDateString() === new Date().toDateString() ) {
                            if (pointDate >= today) {
                                // 7 Tage, 'heute' zählt zu Prognose
                                ctx.fillStyle = colorPrognose;
                            } else {
                                ctx.fillStyle = colors[colorHash][c].color;
                            }
                            break;
                        } else {
                            ctx.fillStyle = colorPrognose;
                        }
                    }
                }
            }
            if (i + 1 < points.length) {
                var dayDiff = (points[i + 1].xval - points[i].xval) / (60 * 60 * 24);
                if (dayDiff > 20) {
                    bar_width = points[i + 1].canvasx - points[i].canvasx;
                    // bar_width abhängig von anzahl der Tage
                    //if (dayDiff != 30) { // start ist 30 tage
                    //	bar_width = startWidth - ((31 - dayDiff) * 4);
                    //}
                    bar_width /= 1.2;
                }

                ctx.fillRect(points[i].canvasx - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);
            } else {
                // letzter balken
                ctx.fillRect(points[i].canvasx - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);
            }




        }
    }

    function daydiff(first, second) {
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }

    function PrognoselinePlotter(e) {
        var ctx = e.drawingContext;
        ctx.strokeStyle = e.color;
        var pointTo = e.allSeriesPoints[e.seriesIndex + 1];
        // Normale Linie der aktuellen Serie
        ctx.beginPath();
        ctx.moveTo(e.points[0].canvasx, e.points[0].canvasy);
        var px = new Array();
        for (var i = 1; i < e.points.length; i++) {
            if (!isNaN(e.points[i].canvasy)) {
                ctx.lineTo(e.points[i].canvasx, e.points[i].canvasy);
                px.push(e.points[i].canvasx);
            }
        }
        ctx.stroke();
        // Prognose mit Hintergrundfarbe
        ctx.beginPath();
        ctx.fillStyle = colorPrognoseBG;
        ctx.fillRect(px[0] - 1, 0, e.plotArea.w, e.plotArea.h + e.plotArea.y - 1);
    }

    /**
     * Plotter füllen zwischen 2 linien
     * Verbindet aktuelle Linie mit der folgenden
     * @param {number} e context
     */
    function fillChartPlotter(e) {

        var ctx = e.drawingContext;
        ctx.strokeStyle = e.color; // "rgba(222,226,238,0.8)";
        var pointTo = e.allSeriesPoints[e.seriesIndex + 1];
        var i = 0;
        // Normale Linie der aktuellen Serie
        ctx.beginPath();
        ctx.moveTo(e.points[0].canvasx, e.points[0].canvasy);
        for (i = 1; i < e.points.length; i++) {
            if (!isNaN(e.points[i].canvasy)) {
                ctx.lineTo(e.points[i].canvasx, e.points[i].canvasy);
            }
        }
        ctx.stroke();


        // Verbindungslinien
        ctx.strokeStyle = "rgba(222,226,238,0.5)";
        for (i = 1; i < e.points.length; i++) {
            ctx.moveTo(e.points[i].canvasx, e.points[i].canvasy);
            ctx.lineTo(pointTo[i].canvasx, pointTo[i].canvasy);
        }
        ctx.stroke();
        // Füllen
        ctx.fillStyle = "rgba(222,226,238,0.3)";
        ctx.beginPath();
        ctx.moveTo(e.points[0].canvasx, e.points[0].canvasy);
        for (i = 1; i < e.points.length; i++) {
            ctx.lineTo(e.points[i].canvasx, e.points[i].canvasy);
        }
        for (i = pointTo.length - 1; i > 0; i--) {
            ctx.lineTo(pointTo[i].canvasx, pointTo[i].canvasy);
        }
        ctx.closePath();
        ctx.fill();
    }

    /**
     * Plotter zum füllen von der x-achse bis zur Linie
     * @param {number} e context
     */
    function filledLinePlotter(e) {
        var ctx = e.drawingContext;
        // Find minimum y
        var min_y = e.points[0].yval;
        var i = 0;
        var p = 0;
        for (i = 1; i < e.Dygraph.points.length; i++) {
            if (isNaN(e.points[i].yval) === false) {
                min_y = Math.min(min_y, e.points[i].yval);
            }
        }
        var y_bottom = e.dygraph.toDomYCoord(min_y * 2); // Ensures filling to x axis
        // Fill
        //    var rgb = new RGBColorParser(e.color);
        //    var err_color = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.15)';
        ctx.fillStyle = e.color;
        ctx.beginPath();
        ctx.moveTo(e.points[0].canvasx, e.points[0].canvasy);
        for (i = 1; i < e.points.length; i++) {
            p = e.points[i];
            ctx.lineTo(p.canvasx, p.canvasy);
        }
        ctx.lineTo(p.canvasx, y_bottom);
        ctx.lineTo(e.points[0].canvasx, y_bottom);
        ctx.lineTo(e.points[0].canvasx, e.points[0].canvasy);
        ctx.closePath();
        ctx.fill();
        // Line
        ctx.beginPath();
        ctx.moveTo(e.points[0].canvasx, e.points[0].canvasy);
        for (i = 1; i < e.points.length; i++) {
            p = e.points[i];
            ctx.lineTo(p.canvasx, p.canvasy);
        }
        ctx.stroke();
    }

}
window.setTimeout(init, 200);
// init();
